import {
  FilterMode,
  UserCreateMutationVariables,
  User_OrderBy,
  User,
  SortOrder,
  User_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const userService = {
  createOne: buildCreateOne(
    (userCreateVariables: UserCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.userCreate(userCreateVariables);
        return result.userCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.userOne({ id });
    return result.userOne as User;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: User_OrderBy[] | null = null,
    filter: User_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: User_Filter | undefined;
    if (searchValue !== "") {
      where = {
        OR: [
          { email: { contains: searchValue, mode: FilterMode.Insensitive } },
          { name: { contains: searchValue, mode: FilterMode.Insensitive } },
        ],
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.userListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ email: SortOrder.Asc }, { name: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(result.userListWithOffset) as User[];
    return { list, orderBy };
  },
};
